import { Text } from 'blaze-ui/Text/Text'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { generatePath, useHistory, useParams } from 'react-router-dom'
import { BRAND_KITS_PATH } from 'paths'
import { BrandKitMoreButton } from 'screens/BrandKit/BrandKitMoreButton/BrandKitMoreButton'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { BrandKitEditableName } from 'screens/BrandKit/BrandKitEditableName/BrandKitEditableName'
import { Pressable } from '@react-aria/interactions'
import { BrandKitLogo } from 'screens/BrandKit/BrandKitLogo/BrandKitLogo'
import Styles from './BrandKitMobileTopBar.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'
import { Button } from 'blaze-ui/Button'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const BrandKitMobileTopBar = () => {
  const theme = useHeaderTheme()
  const { id, workspaceId } = useParams<{ id: string; workspaceId: string }>()
  const history = useHistory()

  const brandKit = useBrandKit(Number(id), { cacheTime: 1000 * 60 * 5 }).data?.brand_kit

  const goToBrandKits = () => {
    history.push(generatePath(BRAND_KITS_PATH, { workspaceId }))
  }

  const { isIOSNative, isMobile } = useResponsiveDesign()
  const workspace = useCurrentWorkspace()
  const isAutopilot = !!workspace?.is_virtual_marketer

  if ((isIOSNative || isMobile) && isAutopilot) {
    return null
  }

  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        <Button onPress={goToBrandKits} variant="editor" rounded>
          Back
        </Button>
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center>
        {!brandKit && (
          <div className={Styles.content}>
            <Skeleton
              avatar={{ size: 30, shape: 'circle' }}
              active
              title={{ width: '80px', style: { marginTop: '8px', borderRadius: '6px', marginLeft: '-6px' } }}
              paragraph={false}
            />
          </div>
        )}
        {brandKit && (
          <div className={Styles.content}>
            <div className={Styles.logo}>
              <BrandKitLogo brandKit={brandKit} />
            </div>
            <BrandKitEditableName
              placement="bottom"
              brandKit={brandKit}
              trigger={
                <Pressable>
                  <Text lineClamp={1} color="var(--dark-80)">
                    {brandKit.name}
                  </Text>
                </Pressable>
              }
            />
          </div>
        )}
      </MobileTopBarContainer.Center>
      <MobileTopBarContainer.Right>
        {brandKit && <BrandKitMoreButton brandKit={brandKit} isMobile />}
      </MobileTopBarContainer.Right>
    </MobileTopBarContainer.Root>
  )
}
